import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type SelectIconProps = RadixSelect.SelectIconProps;

export const SelectIcon = forwardRef<HTMLSpanElement, SelectIconProps>(
  ({ children, className, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.SelectIcon
        asChild
        className={cn('shrink-0 ads:text-icon-subtle text-gray-9', className)}
        {...restOfProps}
        ref={forwardedRef}
      >
        {children ? children : <ChevronDownIcon size="sm" />}
      </RadixSelect.SelectIcon>
    );
  },
);

SelectIcon.displayName = 'SelectIcon';
